export * from './ExperimentDetails';
import ExperimentDetails from './ExperimentDetails';
export default ExperimentDetails;
